export default {"src":"/_next/static/media/logo-header-preta.5bfe2add.svg","height":462,"width":383,"blurWidth":0,"blurHeight":0};